import React from 'react';
import './AboutInnovation.scss';

/**
 * Renders about page innovation module
 * @param {string} title
 * @param {string} body
 * @param {object} imageOne
 * @param {object} imageTwo
 * @param {string} caption
 * @returns {JSX.Element}
 * @constructor
 */
const AboutInnovation = ({ title, body, imageOne, imageTwo, caption = '' }) => (
  <div className="c-about-innovation background-color-gray">
    <div className="c-about-innovation__inner">
      <div className="c-about-innovation__text">
        <div className="c-about-innovation__title h1-roobert">
          <h1>{title}</h1>
        </div>
        <div className="c-about-innovation__body h4-roobert">
          <h4>{body}</h4>
        </div>
      </div>
      <div className="c-about-innovation__images">
        <div className="c-about-innovation__image-one">
          <img src={imageOne.url} alt={imageOne.alt} />
        </div>
        <div className="c-about-innovation__caption-container">
          <div className="c-about-innovation__image-two">
            <img src={imageTwo.url} alt={imageTwo.alt} />
          </div>
          {caption && (
            <div className="c-about-innovation__caption body-3 background-color-blue color-white">
              <p>{caption}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);

export default AboutInnovation;
